module.exports = __webpack_public_path__ + "img/8.4fb5f396.png";